export default "/images/8e61899b52e4b50d1199c22f118aae84.png";